import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useLatestVersion } from '../data/changelogData';
import './SystemUpdateBanner.css';

function SystemUpdateBanner() {
  const [visible, setVisible] = useState(false);
  const location = useLocation();
  const latestVersion = useLatestVersion();

  // Define routes where the banner should never appear
  const hideOnRoutes = ['/resume', '/embed', '/admin'];
  const isExcludedRoute = hideOnRoutes.some(path => location.pathname.startsWith(path));

  // Dynamic version-based acknowledge key
  const versionKey = `devtracker_v4.3.0_acknowledged`;

  useEffect(() => {
    const isAck = localStorage.getItem(versionKey);
    const shouldDisplay = isAck !== 'true' && !isExcludedRoute;

    if (shouldDisplay) {
      setVisible(true);
      document.body.classList.add('banner-active');
    } else {
      setVisible(false);
      document.body.classList.remove('banner-active');
    }
    
    return () => document.body.classList.remove('banner-active');
  }, [location.pathname, isExcludedRoute, versionKey]);

  const handleAcknowledge = () => {
    localStorage.setItem(versionKey, 'true');
    setVisible(false);
    document.body.classList.remove('banner-active');
  };

  // Assuming handleDismiss is the same as handleAcknowledge based on the context
  const handleDismiss = handleAcknowledge;

  if (!visible) return null;

  return (
    <div className="system-update-banner animate-slide-down">
      <div className="banner-content">
        <div className="banner-ai-icon">
          <i className="fa-solid fa-wand-magic-sparkles"></i>
        </div>
        <div className="banner-text">
          <span className="banner-badge">DEV-HUD | SECURITY PATCH</span>
          <p>
            <strong>DevTracker {latestVersion} is Live.</strong> High-Fidelity Extraction refined. 
            <span style={{ color: '#F59E0B', fontWeight: 'bold' }}> [AI & Resume Mode: Active Dev - Expect non-linear behavior]</span>. 
            Security Patch 4.3.0 deployed.
            <Link to={`/whats-new/${latestVersion}`} className="banner-primary-link" onClick={handleAcknowledge}> Changelog</Link> or <Link to="/faq" onClick={handleAcknowledge}>FAQ</Link>.
          </p>
        </div>
        <button className="banner-close" onClick={handleAcknowledge} title="Acknowledge and Close">
          <i className="fa-solid fa-xmark"></i>
        </button>
      </div>
      <div className="banner-progress-glow"></div>
    </div>
  );
}

export default SystemUpdateBanner;
